import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectOrgRegistriesListItems } from "../../../../../../redux/org-registries/selector";
import { orgRegistries } from "../../../../../../redux/org-registries/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementOrgRegistries = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orgRegistryItems = useSelector(selectOrgRegistriesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'AccountName', headerName: 'Account Name'},
          { field: 'OwnedByOUName', headerName: 'OrganizationUnit Name' },
          { field: 'OwnedByOUAccountName', headerName: 'OrganizationUnit AccountName' },
          { field: 'Delivery_preference', headerName: 'Delivery Preference' },
          { field: 'CurrentlyServicing', headerName: 'Currently Servicing', cellRenderer: 'yesNoRenderer' },
          { field: 'IsAcceptOrderByDefaultEnabled', headerName: 'Accept Order By DefaultEnabled', cellRenderer: 'yesNoRenderer' },
          { field: 'IsDirectShipmentEnabled', headerName: 'Direct Shipment Enabled', cellRenderer: 'yesNoRenderer' },
          { field: 'UkId', headerName: 'UkId' },
          { field: 'UseSettingsFromConfigFile', headerName: 'Use Settings From ConfigFile', cellRenderer: 'yesNoRenderer' },
          { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
          { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
      
        ]);
      }
      const fetchOrgRegistry=()=>{

        dispatch(orgRegistries.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/org-registries/list`,entity:'orgRegistries',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
       
      } 
	useEffect(() => {
        createColumnDefs()
        fetchOrgRegistry()
	}, [pageData])
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    
    navigate(`${data?.Id}`)
  }
  const additionButtons: any = [
    {
      name: 'Add OrgRegistry',
      callback: () => handleAdd(),
    }
  ];
  const handleDelete=(data: any)=>{
    dispatch(orgRegistries.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/org-registries/delete`,
      entity: 'orgRegistries',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(orgRegistries.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/org-registries/list`,entity:'orgRegistries',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    
    }}))
  });
  }
	return (
    <>
    {orgRegistryItems?.isLoading ? 
<PageLoader />
: 
		<Table columnData={columnDefs} rowData={orgRegistryItems?.result?.items} setPageData={setPageData} 
    paginationData={orgRegistryItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="OrgRegistry" />
  }
  </>

	);
};

export default ManagementOrgRegistries;


